import { useCallback } from 'react'
import useAppDispatch from './useAppDispatch'
import useAppSelector from './useAppSelector'
import { 
  addCriticalRequest, 
  completeCriticalRequest, 
  removeCriticalRequest 
} from '../redux/features/loading/loadingSlice'

export const useCriticalRequests = () => {
  const dispatch = useAppDispatch()
  const { criticalRequests, isLoading, isAppReady } = useAppSelector(state => state.loading)

  // Add a critical request
  const addRequest = useCallback((requestId, description) => {
    dispatch(addCriticalRequest({ requestId, description }))
  }, [dispatch])

  // Complete a critical request
  const completeRequest = useCallback((requestId, status = 'success') => {
    dispatch(completeCriticalRequest({ requestId, status }))
  }, [dispatch])

  // Remove a critical request
  const removeRequest = useCallback((requestId) => {
    dispatch(removeCriticalRequest(requestId))
  }, [dispatch])

  // Wrapper for API calls with automatic loading state
  const executeCriticalRequest = useCallback(async (requestId, description, apiCall) => {
    try {
      addRequest(requestId, description)
      const result = await apiCall()
      completeRequest(requestId, 'success')
      return result
    } catch (error) {
      console.error(`Critical request ${requestId} failed:`, error)
      completeRequest(requestId, 'error')
      // Do not rethrow so the app is not blocked
      return null
    }
  }, [addRequest, completeRequest])

  return {
    criticalRequests,
    isLoading,
    isAppReady,
    addRequest,
    completeRequest,
    removeRequest,
    executeCriticalRequest
  }
}

export default useCriticalRequests
